// extracted by mini-css-extract-plugin
export default {"badge-button-wrapper":"_2IK9v","badgeButtonWrapper":"_2IK9v","badge-button":"svstc","badgeButton":"svstc","badge":"_2IQqc"};